export default __webpack_public_path__ + "static/media/flag-no.0f44f114.svg";